<script setup lang="ts">
  import { computed, ref } from 'vue';

  import type { SMSJSON } from '@stuut/api/models';
  import { Textarea } from '@ui/components/textarea';

  import { SmsTemplateVariableSelect } from '@/components/sms-templates';

  interface Props {
    disabled?: boolean;
    draftedBody?: string;
    sms?: SMSJSON;
  }

  const props = defineProps<Props>();

  const body = ref(props.draftedBody ?? '');

  const characterCount = computed(() => body.value.trim().length);

  const insertVariable = (variable: { name: string; displayName: string }) => {
    body.value += `{{ ${variable.name} }}`;
  };

  defineExpose({
    body,
    sms: props.sms,
  });
</script>

<template>
  <div class="space-y-4">
    <Textarea
      v-model="body"
      placeholder="Type your SMS message..."
      class="min-h-[120px] resize-none text-xs"
      :disabled="disabled"
    />

    <div class="flex items-center justify-between">
      <div class="text-xs text-muted-foreground">
        <span>{{ characterCount }} characters</span>
      </div>

      <SmsTemplateVariableSelect @variable-selected="insertVariable" />
    </div>
  </div>
</template>
